<div class="map-wrapper">
    <div class="header-container">
        <h2>Preview Location</h2>
        <button class="mat-button icon-button close" aria-label="close dialog" [mat-dialog-close]="">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <google-map [width]="null" [height]="null" [options]="mapOptions">
        <map-marker [position]="marker?.position"></map-marker>
    </google-map>
</div>
